export default function ArticleDescriptionHeight(context) {
    if (MNTK.deviceType === 'd') {
        const LINK_HEIGHT = 24;
        const MARGIN_BOTTOM = 10;
        const PADDING = 20;

        const $articles = context.querySelectorAll('.article_bg-color');
        $articles.forEach($article => {
            const $title = $article.querySelector('.article__title');
            const $description = $article.querySelector(
                '.article__description'
            );
            const articleHeight = $article.offsetHeight;
            const titleHeight = $title.offsetHeight;
            const descriptionHeight = $description.offsetHeight;
            const maxDescriptionHeight =
                articleHeight -
                PADDING * 2 -
                titleHeight -
                LINK_HEIGHT -
                MARGIN_BOTTOM * 3;

            if (descriptionHeight > maxDescriptionHeight) {
                $description.classList.add('with-gradient');
                $description.style.maxHeight = `${maxDescriptionHeight}px`;
            }
        });
    }
}
